// extracted by mini-css-extract-plugin
export var root = "index-module--root--f1313";
export var textContainer = "index-module--textContainer--1b178";
export var title = "index-module--title--155a9";